import { Component, Input, inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-bid-reserve-price',
  templateUrl: './bid-reserve-price.component.html',
  styleUrls: ['./bid-reserve-price.component.scss'],
  standalone: true,
  imports: [NgIf, TranslatePipe],
})
export class BidReservePriceComponent {
  @Input() reservePrice: number;
  @Input() idAuction: number;

  activeModal = inject(NgbActiveModal);

}
